module.exports = __webpack_public_path__ + "img/logo.122a8b4d.png";